import { get } from 'lodash';
import { RECURRING_NONE_OPTION } from './constants';

export const getDefaultRecurringOptionId = (recurringOptions = []) => {
    const recurringOption = getDefaultRecurringOption(recurringOptions);

    return get(recurringOption, 'id');
};

export const getDefaultRecurringOption = (recurringOptions = []) => {
    const [recurringOption] = recurringOptions;

    return recurringOption;
};

export const isNoneRecurringOption = (recurringOptionId) =>
    recurringOptionId === RECURRING_NONE_OPTION.id;
